import React, { FC } from 'react'

import { Box, Icon, IconButton, Typography } from '@popmenu/common-ui'
import { X as XIcon } from '@popmenu/web-icons'
import { FullScreenStepperProgress } from '../FullScreenStepperProgress'
import { FullScreenStepperHeaderProps } from './FullScreenStepperHeaderProps'
import { useFullScreenStepperHeaderStyles } from './FullScreenStepperHeaderStyles'

export const FullScreenStepperHeader: FC<FullScreenStepperHeaderProps> = (props) => {
  const { stepCount, stepCursor, step, onClose } = props
  const classes = useFullScreenStepperHeaderStyles(props)
  return (
    <Box className={classes.root}>
      <Typography variant="h6">{step.title}</Typography>
      <Typography>
        {stepCursor} of {stepCount}
      </Typography>
      <IconButton className={classes.closeButton} onClick={onClose}>
        <Icon icon={XIcon} />
      </IconButton>
      <FullScreenStepperProgress stepCount={stepCount} stepCursor={stepCursor} />
    </Box>
  )
}
